import { colors } from "@/theme";

/**
 * EmberOrb — warm glowing "ember" avatar, CSS gradient port of the mobile orb.
 */
export default function EmberOrb({ size = 150, active = false }) {
  const inner = size * 0.76;
  const hl = inner * 0.5;
  return (
    <div
      style={{
        width: size,
        height: size,
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: size,
          height: size,
          borderRadius: "50%",
          background: colors.brandTertiary,
          opacity: active ? 0.95 : 0.6,
          filter: "blur(10px)",
        }}
      />
      <div
        style={{
          position: "relative",
          width: inner,
          height: inner,
          borderRadius: "50%",
          overflow: "hidden",
          background: `linear-gradient(145deg, ${colors.brandTertiary} 0%, ${colors.brandSecondary} 45%, ${colors.brandPrimary} 100%)`,
          boxShadow: active ? `0 0 28px ${colors.brandSecondary}` : "none",
          transition: "box-shadow 0.4s ease",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: hl,
            height: hl,
            borderRadius: "50%",
            top: inner * 0.13,
            left: inner * 0.15,
            background: "rgba(255,255,255,0.45)",
            filter: "blur(2px)",
          }}
        />
      </div>
    </div>
  );
}
